import React, { Component } from 'react';
import { SUPPLIER_DETAIL, CLIENTS_DETAIL } from '../../constants/routes';
import SearchSupplierDetail from './SearchSupplierDetail';
import { Link } from 'react-router-dom';

import { TYPE_SUPPLIER } from '../../constants/clientTypes';

export default class SearchSupplier extends Component {

	constructor(props) {
		super(props)
		this.state = { 
			isDetailOpen: false
        };
        this.showDetail = this.showDetail.bind(this)
	}

	showDetail() {
		this.setState(state => ({
			isDetailOpen: !state.isDetailOpen
		}));
    }

  render() {
    const { client } = this.props;

    return (
        <div className="inwork-item" key={ client.id }>
            <button className={ this.state.isDetailOpen ? 'btn btn-default inwork_date__detail_icon detail_open' : 'btn btn-default inwork_date__detail_icon detail_close'} type="button" onClick={ this.showDetail }>+</button>
            <span className="inwork-date">{ client.date_will_call } </span>
            <Link to={`${ +client.type === TYPE_SUPPLIER ? SUPPLIER_DETAIL : CLIENTS_DETAIL }?id=${ client.id }`}>{ client.name }</Link>
            { this.state.isDetailOpen ? 
            <SearchSupplierDetail detail={ client.detail }/> 
            : null }
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./components/Search/SearchSupplier.js